var map = {
	"./altf/logo.png": "34a3",
	"./datarmony/logo.png": "513c",
	"./default/logo.png": "875e",
	"./euruni/logo.png": "7862",
	"./foundever/logo.png": "1f2d",
	"./gala/logo.png": "a583",
	"./ie/logo.png": "645a",
	"./sitel-learning-sandbox/logo.png": "d998",
	"./sitel-learning/logo.png": "43da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7e5";